/**
 * Account settings page component for lite home navigation
 */

import { Stack } from "@mantine/core";
import { useEffect, useState } from "react";
import type { PersonalInfoSettings } from "@/types";
import SettingsHeader from "@/pages/Settings/SettingsHeader/SettingsHeader";
import PersonalInfoSetting from "@/pages/PersonalInfoSetting/PersonalInfoSetting";
import ChangePassword from "@/components/ChangePassword/ChangePassword";
import { changePassword } from "@/utils/api";

interface AccountSettingsPageProps {
  onExit?: () => void;
}

const AccountSettingsPage: React.FC<AccountSettingsPageProps> = () => {
  const storedPersonalInfo = localStorage.getItem("personalInfo");
  const initialPersonalInfo: PersonalInfoSettings = storedPersonalInfo
    ? JSON.parse(storedPersonalInfo)
    : {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
      };

  const [personalInfo, setPersonalInfo] =
    useState<PersonalInfoSettings>(initialPersonalInfo);
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Keep local state in sync with localStorage updates
  useEffect(() => {
    const onStorage = () => {
      const pi = localStorage.getItem("personalInfo");
      if (pi) setPersonalInfo(JSON.parse(pi));
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <Stack gap="md">
      <SettingsHeader
        title="Account"
        description="Manage your account information"
      />
      <PersonalInfoSetting
        personalInfo={personalInfo}
        setPersonalInfo={setPersonalInfo}
      />
      <ChangePassword
        password={password}
        setPassword={setPassword}
        updatePassword={changePassword}
      />
    </Stack>
  );
};

export default AccountSettingsPage;
